/* eslint-disable */
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by a tool.
//
//
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { GenericHeaderBase, TagsBase, VimeoBase, ScriptAsset } from "~/foundation/SitecoreContent/generated-types";
import { VariantOnlyRenderingParameters, ThemeRenderingParameters, ModuleThemeBase } from "~/foundation/Theme/generated-types";
import { _IndexedItem } from "~/foundation/Indexing/generated-types";
import { JssField, ItemReference, TextField, RichTextField, FileField, LinkField, ImageField, Rendering, SerializedItem, Prettify } from "~/foundation/Jss";
import { FormFieldSection } from './../../foundation/SitecoreContent/generated-types';
import { JssLinkFieldValue } from './../../foundation/Jss/generated-types';

export type ReportPageHeroModel = {
    vimeoVideoRatio: number;
};
export type HeroCarouselModel = {
    slides?: HeroCarouselSlideModel[];
};
export type VideoModel = {
    thumbnailSm?: string;
    thumbnailMd?: string;
    thumbnailLg?: string;
    thumbnailXl?: string;
    duration?: number;
    uploadDate?: string;
    title?: string;
    description?: string;
};
export type ImageCarouselModel = {
    slides?: ImageCarouselSlideModel[];
};
export type TeaserModel = {
    teaserType: ColumnType;
};
export type DocumentsListTwoColumnModel = {
    sections?: DocumentsListTwoColumnSectionModel[];
};
export type DocumentsListModel = {
    columnType: ColumnType;
};
export type CareerWidgetModel = {
    form: {
        [key: string]: FormFieldSection;
    };
};
export type MicroCardsModel = {
    microCards: MicroCardModel[];
};
export type HeroCarouselSlideModel = {
    backgroundImage?: ImageField;
    backgroundVideo?: FileField;
    trumpet?: TextField;
    headline?: TextField;
    primaryLink?: LinkField;
    secondaryLink?: LinkField;
};
export type ImageCarouselSlideModel = {
    source?: ImageField;
    captionTitle?: TextField;
    captionText?: TextField;
    captionLink?: LinkField;
    imageRatio?: string;
};
export enum ColumnType {
    Default = 0,
    OneColumn = 1,
    TwoColumn = 2,
    ChapterTeaser = 3,
}
export type DocumentsListTwoColumnSectionModel = {
    title?: string;
    files?: DocumentsListTwoColumnFileModel[];
};
export type MicroCardModel = {
    id: string;
    headline?: TextField;
    description?: RichTextField;
    image?: ImageField;
    link?: LinkField;
    referenceLinkText?: TextField;
    editable: boolean;
};
export type DocumentsListTwoColumnFileModel = {
    title?: string;
    publishDate?: (Date | string);
    asset?: JssLinkFieldValue;
    link?: JssLinkFieldValue;
};


// Item: 920a1781-559f-4e1c-bb2e-6b9a2113fe6b - /sitecore/templates/FeatureJss/Media/Media Folder
export type MediaFolder = {
}

// Item: beccb5ea-6b26-4502-bf1e-49bea92b0126 - /sitecore/templates/FeatureJss/Media/Base/Caption Base
export type CaptionBase = {
  captionLink?: LinkField;
  captionText?: TextField;
  captionTitle?: TextField;
}

// Item: 23f8b2ac-1ff0-465b-afcc-45d17761bd6d - /sitecore/templates/FeatureJss/Media/Base/Caption Simple Base
export type CaptionSimpleBase = {
  captionText?: TextField;
}

// Item: 8f9c2f9b-b604-4c2c-b49f-c772b0b10988 - /sitecore/templates/FeatureJss/Media/Base/Card Base
export type CardBase = {
  image?: ImageField;
  link?: LinkField;
  title?: TextField;
  trumpet?: TextField;
}

// Item: 47f5bfb8-eb13-4c02-a7ef-fb0f957d21ef - /sitecore/templates/FeatureJss/Media/Base/Key Number Base
export type KeyNumberBase = {
  extendNumberWithDecimalZero?: JssField<boolean>;
  keyNumberCaption?: JssField;
  keyNumberDescription?: JssField;
  keyNumberFigure?: JssField<number>;
}

// Item: af10ee02-a7e5-4901-8bd2-90f50610133d - /sitecore/templates/FeatureJss/Media/Base/Micro Card Base
export type MicroCardBase = {
  description?: RichTextField;
  headline?: TextField;
  image?: ImageField;
  link?: LinkField;
}

// Item: 00f230cc-187e-4df4-81d2-bcb60a51d5ed - /sitecore/templates/FeatureJss/Media/Base/Orientation Base
export type OrientationBase = {
  orientation?: JssField<string>;
}

// Comment: Inherits a08d21d1-186b-40a3-bb21-2b919abea9a4 - /sitecore/templates/FeatureJss/Media/Base/Teaser Base
// Item: 22371447-bdd5-4512-abd0-2f1b9a2a378c - /sitecore/templates/FeatureJss/Media/Base/Split Teaser Base
export type SplitTeaserBase = TeaserBase & {
  teaserSecondaryLink1?: LinkField;
  teaserSecondaryLink2?: LinkField;
  teaserTrumpet?: TextField;
}

// Comment: Inherits 23f8b2ac-1ff0-465b-afcc-45d17761bd6d - /sitecore/templates/FeatureJss/Media/Base/Caption Simple Base
// Item: a08d21d1-186b-40a3-bb21-2b919abea9a4 - /sitecore/templates/FeatureJss/Media/Base/Teaser Base
export type TeaserBase = CaptionSimpleBase & {
  teaserDescription?: RichTextField;
  teaserHeadline?: TextField;
  teaserImage?: ImageField;
  teaserLink?: LinkField;
}

// Item: ad7bda77-8f8a-4062-b630-5a8321b00739 - /sitecore/templates/FeatureJss/Media/Base/_MediaSearchData
export type _MediaSearchData = {
  description?: JssField;
  publishDate?: JssField<string>;
  title?: TextField;
}

// Item: 7a16f03d-db85-4ecf-b53c-f25e8982b8a1 - /sitecore/templates/FeatureJss/Media/Business Model/Business Model Marker
export type BusinessModelMarker = {
  markerKey?: TextField;
  markerPositionX?: JssField<number>;
  markerPositionY?: JssField<number>;
  markerText?: RichTextField;
  mask?: TextField;
}

// Comment: Used by 9cdbf62d-5b79-4194-a31e-2d77417882dc - /sitecore/layout/Renderings/FeatureJss/Media/M126 Business Model
// Comment: Inherits d304a713-73c8-470e-9c58-cdb3ec174ac9 - /sitecore/templates/Foundation/SitecoreContent/Content/Base/Generic Header Base
// Item: 958d0dd9-9df4-4bef-8298-7fd4d2f23e79 - /sitecore/templates/FeatureJss/Media/Business Model/Business Model
export type BusinessModel = GenericHeaderBase & {
  businessModelBackgroundVideo?: FileField;
  businessModelImage?: ImageField;
}

// Comment: Inherits 47f5bfb8-eb13-4c02-a7ef-fb0f957d21ef - /sitecore/templates/FeatureJss/Media/Base/Key Number Base
// Item: c0654ee7-8ffb-465b-b7b4-3296aeb4ca17 - /sitecore/templates/FeatureJss/Media/Business Model/Key Number
export type KeyNumber = KeyNumberBase & {
}

// Comment: Used by b04b39d5-2e92-4144-93d0-4b3c083da1be - /sitecore/layout/Renderings/FeatureJss/Media/M25 Card Container
// Comment: Inherits d304a713-73c8-470e-9c58-cdb3ec174ac9 - /sitecore/templates/Foundation/SitecoreContent/Content/Base/Generic Header Base
// Item: b13cde64-7cdb-418e-9e86-6f0a207e275a - /sitecore/templates/FeatureJss/Media/Card/Card Container
export type CardContainer = GenericHeaderBase & {
}

// Comment: Used by d7aed53d-705a-418b-a260-d3557d06cc4e - /sitecore/layout/Renderings/FeatureJss/Media/M89 Card
// Comment: Inherits 8f9c2f9b-b604-4c2c-b49f-c772b0b10988 - /sitecore/templates/FeatureJss/Media/Base/Card Base
// Item: db03d995-ed8e-4aad-8881-fe114f5e61df - /sitecore/templates/FeatureJss/Media/Card/Card
export type Card = CardBase & {
}

// Comment: Inherits af10ee02-a7e5-4901-8bd2-90f50610133d - /sitecore/templates/FeatureJss/Media/Base/Micro Card Base
// Item: f28110e1-4453-4162-a640-de5261249887 - /sitecore/templates/FeatureJss/Media/Card/Micro Card
export type MicroCard = MicroCardBase & {
}

// Item: 8f91d8b0-5c3d-4c2a-9bce-74f928a64649 - /sitecore/templates/FeatureJss/Media/Card/Micro Cards Folder
export type MicroCardsFolder = {
}

// Comment: Used by 031d9b2d-ba42-48e2-b710-3c2167ae4645 - /sitecore/layout/Renderings/FeatureJss/Media/M93 Micro Cards
// Comment: Inherits d304a713-73c8-470e-9c58-cdb3ec174ac9 - /sitecore/templates/Foundation/SitecoreContent/Content/Base/Generic Header Base
// Item: b4e335c8-4a81-4fa5-b7b8-94219864bafd - /sitecore/templates/FeatureJss/Media/Card/Micro Cards
export type MicroCards = GenericHeaderBase & {
}

// Comment: Used by d7aed53d-705a-418b-a260-d3557d06cc4e - /sitecore/layout/Renderings/FeatureJss/Media/M89 Card
// Comment: Inherits 3a63fb86-5836-4fb6-8f4a-27ddb23e3c4b - /sitecore/templates/Foundation/Theme/Variant Only Rendering Parameters
// Item: 683b88b8-e578-4ac0-9efb-fbd46e8efe80 - /sitecore/templates/FeatureJss/Media/Card/ParametersTemplate_Card
export type ParametersTemplate_Card = {
  variant?: string; // code:Foundation.Theme.FieldSources.VariantSource,Foundation.Theme
}

// Comment: Used by b04b39d5-2e92-4144-93d0-4b3c083da1be - /sitecore/layout/Renderings/FeatureJss/Media/M25 Card Container
// Comment: Inherits fc5564f8-c228-4be6-89c9-172d228baf28 - /sitecore/templates/Foundation/Theme/Theme Rendering Parameters
// Item: 7df5605b-761d-46db-a875-65267575335a - /sitecore/templates/FeatureJss/Media/Card/ParametersTemplate_CardContainer
export type ParametersTemplate_CardContainer = {
  backgroundTheme?: string; // code:Foundation.Theme.FieldSources.ThemeSource,Foundation.Theme
  usePageTheme?: "1" | ""; 
  variant?: string; // code:Foundation.Theme.FieldSources.VariantSource,Foundation.Theme
}

// Comment: Used by c5422b0c-bf36-472b-967b-09a7f28b6819 - /sitecore/layout/Renderings/FeatureJss/Media/M70 Careers Widget
// Item: ad68c910-11eb-46e1-bb70-52f97dc90ff1 - /sitecore/templates/FeatureJss/Media/Careers Widget/Careers Widget
export type CareersWidget = {
}

// Comment: Used by 27bb4599-9fbd-43a8-9d9c-0a0e9c0b1b4f - /sitecore/layout/Renderings/FeatureJss/Media/M120 Chapter Teaser Quote
// Comment: Inherits d304a713-73c8-470e-9c58-cdb3ec174ac9 - /sitecore/templates/Foundation/SitecoreContent/Content/Base/Generic Header Base
// Comment: Inherits dbb155cd-3528-42fa-b20c-124efa7a50e0 - /sitecore/templates/FeatureJss/Media/Chapter Teaser/Base/Chapter Teaser Quote Base
// Item: 81237ef7-296c-4421-831b-d4484fd8d12e - /sitecore/templates/FeatureJss/Media/Chapter Teaser/Chapter Teaser Quote
export type ChapterTeaserQuote = GenericHeaderBase & ChapterTeaserQuoteBase & {
}

// Comment: Used by 05c4b1ba-16ae-4b47-8c71-2b4420919070 - /sitecore/layout/Renderings/FeatureJss/Media/M119 Chapter Teaser
// Item: 106ebc54-3c97-472a-a171-e95c340eff72 - /sitecore/templates/FeatureJss/Media/Chapter Teaser/Chapter Teaser Rendering Parameters
export type ChapterTeaserRenderingParameters = {
  orientation?: "0" | "1" | ""; // Default orientation=0|Reverse orientation=1
}

// Comment: Used by 05c4b1ba-16ae-4b47-8c71-2b4420919070 - /sitecore/layout/Renderings/FeatureJss/Media/M119 Chapter Teaser
// Comment: Inherits d304a713-73c8-470e-9c58-cdb3ec174ac9 - /sitecore/templates/Foundation/SitecoreContent/Content/Base/Generic Header Base
// Comment: Inherits 923dfbc6-7d06-4123-8704-0c3443f09d44 - /sitecore/templates/FeatureJss/Media/Chapter Teaser/Base/Chapter Teaser Base
// Item: 64e0d71d-1b19-4149-9b34-3091916099c1 - /sitecore/templates/FeatureJss/Media/Chapter Teaser/Chapter Teaser
export type ChapterTeaser = GenericHeaderBase & ChapterTeaserBase & {
}

// Item: 923dfbc6-7d06-4123-8704-0c3443f09d44 - /sitecore/templates/FeatureJss/Media/Chapter Teaser/Base/Chapter Teaser Base
export type ChapterTeaserBase = {
  chapterTeaser2Description?: JssField;
  chapterTeaser2Headline?: TextField;
  chapterTeaser2Image?: ImageField;
  chapterTeaser4Description?: JssField;
  chapterTeaser4Headline?: TextField;
  chapterTeaser4Image?: ImageField;
  chapterTeaser1Description?: JssField;
  chapterTeaser1Headline?: TextField;
  chapterTeaser1Image?: ImageField;
  chapterTeaser3Description?: JssField;
  chapterTeaser3Headline?: TextField;
  chapterTeaser3Image?: ImageField;
  chapterTeaser1Link?: LinkField;
  chapterTeaser2Link?: LinkField;
  chapterTeaser4Link?: LinkField;
}

// Item: dbb155cd-3528-42fa-b20c-124efa7a50e0 - /sitecore/templates/FeatureJss/Media/Chapter Teaser/Base/Chapter Teaser Quote Base
export type ChapterTeaserQuoteBase = {
  chapterQuoteAuthor?: TextField;
  chapterQuotelink?: LinkField;
  chapterQuoteText?: TextField;
  chapterTeaser3Description?: JssField;
  chapterTeaser3Headline?: TextField;
  chapterTeaser3Image?: ImageField;
  chapterTeaser3Link?: LinkField;
  chapterTeaser2Description?: JssField;
  chapterTeaser2Headline?: TextField;
  chapterTeaser2Image?: ImageField;
  chapterTeaser2Link?: LinkField;
  chapterTeaser1Description?: JssField;
  chapterTeaser1Headline?: TextField;
  chapterTeaser1Image?: ImageField;
  chapterTeaser1Link?: LinkField;
}

// Item: 656bb6d8-813b-4c93-bc2e-7d64027a3115 - /sitecore/templates/FeatureJss/Media/Document List/Document List Folder
export type DocumentListFolder = {
}

// Comment: Used by 56774e05-9071-4d43-9ec2-914af3ce6d25 - /sitecore/layout/Renderings/FeatureJss/Media/M125 Document List Grid
// Item: 0c4b62e7-7901-40e8-b791-4dae4fa2ae44 - /sitecore/templates/FeatureJss/Media/Document List/Document List Grid
export type DocumentListGrid = {
}

// Comment: Inherits 3d54f9c4-04e8-40c6-b02e-27e9e726a49c - /sitecore/templates/FeatureJss/Media/Document List/Base/Document List Item Base
// Item: a81ce46b-eda4-46ea-86b2-70b3e30e3238 - /sitecore/templates/FeatureJss/Media/Document List/Document List Item
export type DocumentListItem = DocumentListItemBase & {
}

// Comment: Used by 56774e05-9071-4d43-9ec2-914af3ce6d25 - /sitecore/layout/Renderings/FeatureJss/Media/M125 Document List Grid
// Comment: Inherits fc5564f8-c228-4be6-89c9-172d228baf28 - /sitecore/templates/Foundation/Theme/Theme Rendering Parameters
// Item: 21779c14-4072-4ef6-8521-f6db9d65522b - /sitecore/templates/FeatureJss/Media/Document List/Document List Rendering Parameters
export type DocumentListRenderingParameters = {
  maxVisibleItems?: string; 
  backgroundTheme?: string; // code:Foundation.Theme.FieldSources.ThemeSource,Foundation.Theme
  usePageTheme?: "1" | ""; 
  variant?: string; // code:Foundation.Theme.FieldSources.VariantSource,Foundation.Theme
}

// Comment: Inherits 26696c93-0317-40a2-9912-79b68608462c - /sitecore/templates/FeatureJss/Media/Document List/Base/Document List Section Base
// Item: 321e0eed-cf7f-42c4-8abe-20c00ea9a51b - /sitecore/templates/FeatureJss/Media/Document List/Document List Section
export type DocumentListSection = DocumentListSectionBase & {
}

// Comment: Inherits b90bc79e-4d84-406f-acfe-6686988dd79d - /sitecore/templates/FeatureJss/Media/Document List/Base/Document List Tab Base
// Item: b3190ff6-afda-40e5-b8c6-d53e41983bd9 - /sitecore/templates/FeatureJss/Media/Document List/Document List Tab
export type DocumentListTab = DocumentListTabBase & {
}

// Item: 619afc6d-fceb-4c98-b3d4-ce40bbeac5fe - /sitecore/templates/FeatureJss/Media/Document List/Document List Text
export type DocumentListText = {
  text?: RichTextField;
  title?: TextField;
}

// Comment: Used by 4e6ed550-5ae9-4a84-97d9-f19ee6922786 - /sitecore/layout/Renderings/FeatureJss/Media/M55 Document List
// Comment: Inherits 8259e71d-2540-40ab-96c9-2c5beed5ede2 - /sitecore/templates/FeatureJss/Media/Document List/Base/Document List Base
// Comment: Inherits d304a713-73c8-470e-9c58-cdb3ec174ac9 - /sitecore/templates/Foundation/SitecoreContent/Content/Base/Generic Header Base
// Item: 623f6168-d3b0-41c9-ba7f-987bcc8df895 - /sitecore/templates/FeatureJss/Media/Document List/Document List
export type DocumentList = DocumentListBase & GenericHeaderBase & {
}

// Comment: Used by 3d88aae4-3cb5-4b95-9c83-2216e20823de - /sitecore/layout/Renderings/FeatureJss/Media/M55 Document List Two Column
// Comment: Inherits d304a713-73c8-470e-9c58-cdb3ec174ac9 - /sitecore/templates/Foundation/SitecoreContent/Content/Base/Generic Header Base
// Item: 7de11adc-9b8c-431a-9f4e-3b32ea91ed72 - /sitecore/templates/FeatureJss/Media/Document List/Documents List Two Column
export type DocumentsListTwoColumn = GenericHeaderBase & {
}

// Item: 8259e71d-2540-40ab-96c9-2c5beed5ede2 - /sitecore/templates/FeatureJss/Media/Document List/Base/Document List Base
export type DocumentListBase = {
}

// Item: 3d54f9c4-04e8-40c6-b02e-27e9e726a49c - /sitecore/templates/FeatureJss/Media/Document List/Base/Document List Item Base
export type DocumentListItemBase = {
  asset?: LinkField;
  link?: LinkField;
  publishDate?: JssField<string>;
  title?: TextField;
}

// Item: 26696c93-0317-40a2-9912-79b68608462c - /sitecore/templates/FeatureJss/Media/Document List/Base/Document List Section Base
export type DocumentListSectionBase = {
  title?: TextField;
}

// Item: b90bc79e-4d84-406f-acfe-6686988dd79d - /sitecore/templates/FeatureJss/Media/Document List/Base/Document List Tab Base
export type DocumentListTabBase = {
  title?: TextField;
}

// Item: d59780fd-78a6-4ad8-a099-3eb0f3525d3e - /sitecore/templates/FeatureJss/Media/Gallery/Media Gallery List
export type MediaGalleryList = {
}

// Item: 585f32bc-bab9-4df5-865e-474797f8b037 - /sitecore/templates/FeatureJss/Media/Hero/Hero Carousel Folder
export type HeroCarouselFolder = {
}

// Comment: Inherits 76b89499-c2ab-430b-b827-1d03ec019e8f - /sitecore/templates/FeatureJss/Media/Hero/Base/Hero Carousel Slide Base
// Item: 2fd6d3d7-d0e3-4d28-abdb-1b14cad79208 - /sitecore/templates/FeatureJss/Media/Hero/Hero Carousel Slide
export type HeroCarouselSlide = HeroCarouselSlideBase & {
}

// Comment: Used by acf5f9f9-6615-475a-9111-41b1e42cf23e - /sitecore/layout/Renderings/FeatureJss/Media/M08 Hero Carousel
// Comment: Inherits 215b2580-f840-4608-910b-15b41832929d - /sitecore/templates/FeatureJss/Media/Hero/Base/Hero Carousel Base
// Item: c8335e28-bc5a-4f58-8172-bbd4a3a995a5 - /sitecore/templates/FeatureJss/Media/Hero/Hero Carousel
export type HeroCarousel = HeroCarouselBase & {
}

// Comment: Used by 3136006e-ec46-491c-98c2-ab4e41642f91 - /sitecore/layout/Renderings/FeatureJss/Media/M112 Hero
// Comment: Inherits 637a0bf0-8ad2-4e04-9b15-87b80ab39222 - /sitecore/templates/FeatureJss/Media/Hero/Base/Hero Base
// Item: f765a7b0-bd3b-4d65-a937-54ea561bfdd4 - /sitecore/templates/FeatureJss/Media/Hero/Hero
export type Hero = HeroBase & {
}

// Item: 637a0bf0-8ad2-4e04-9b15-87b80ab39222 - /sitecore/templates/FeatureJss/Media/Hero/Base/Hero Base
export type HeroBase = {
  backgroundImage?: ImageField;
  backgroundVideo?: FileField;
  headline?: TextField;
  primaryLink?: LinkField;
  secondaryLink?: LinkField;
  trumpet?: TextField;
}

// Item: 215b2580-f840-4608-910b-15b41832929d - /sitecore/templates/FeatureJss/Media/Hero/Base/Hero Carousel Base
export type HeroCarouselBase = {
}

// Item: 76b89499-c2ab-430b-b827-1d03ec019e8f - /sitecore/templates/FeatureJss/Media/Hero/Base/Hero Carousel Slide Base
export type HeroCarouselSlideBase = {
  backgroundImage?: ImageField;
  backgroundVideo?: FileField;
  headline?: TextField;
  primaryLink?: LinkField;
  secondaryLink?: LinkField;
  trumpet?: TextField;
}

// Item: cf669dca-0679-48bd-a51a-56db64ebc51c - /sitecore/templates/FeatureJss/Media/Hero/Base/Hero Disclaimer Text Base
export type HeroDisclaimerTextBase = {
  disclaimerText?: TextField;
}

// Comment: Used by 2375cbbd-4aef-449d-9a48-bb56e0906a1b - /sitecore/layout/Renderings/FeatureJss/Media/M17 Image
// Comment: Inherits fc5564f8-c228-4be6-89c9-172d228baf28 - /sitecore/templates/Foundation/Theme/Theme Rendering Parameters
// Comment: Inherits 7207d83d-5518-4843-867e-55f5b5ffec22 - /sitecore/templates/Foundation/Theme/Base/Module Theme Base
// Item: 500adb47-5493-46b3-8f85-ca623ac05d0c - /sitecore/templates/FeatureJss/Media/Image/Image Rendering Parameters
export type ImageRenderingParameters = {
  imageRatio?: "" | "1" | "2" | ""; // Default=|Uncropped wide=1|Uncropped narrow=2
  moduleSpacing?: string; // None=none
  backgroundTheme?: string; // code:Foundation.Theme.FieldSources.ThemeSource,Foundation.Theme
  usePageTheme?: "1" | ""; 
  variant?: string; // code:Foundation.Theme.FieldSources.VariantSource,Foundation.Theme
}

// Comment: Used by 2375cbbd-4aef-449d-9a48-bb56e0906a1b - /sitecore/layout/Renderings/FeatureJss/Media/M17 Image
// Comment: Inherits 47ab2da3-4aac-4f7e-8daf-504feb694ea8 - /sitecore/templates/FeatureJss/Media/Image/Base/Image Base
// Comment: Inherits d304a713-73c8-470e-9c58-cdb3ec174ac9 - /sitecore/templates/Foundation/SitecoreContent/Content/Base/Generic Header Base
// Item: f0369e1a-9030-4a05-a09c-ef09b664ed27 - /sitecore/templates/FeatureJss/Media/Image/Image
export type Image = ImageBase & GenericHeaderBase & {
}

// Comment: Inherits 75d399e5-edea-475f-8179-4df293ab2d6d - /sitecore/templates/FeatureJss/Media/Image/Base/_MediaSearchCategory
// Item: 1abd32a9-5a95-4a9d-a55f-a2bdb4ae97b4 - /sitecore/templates/FeatureJss/Media/Image/Media Search Category
export type MediaSearchCategory = _MediaSearchCategory & {
}

// Comment: Inherits 47ab2da3-4aac-4f7e-8daf-504feb694ea8 - /sitecore/templates/FeatureJss/Media/Image/Base/Image Base
// Comment: Inherits ad7bda77-8f8a-4062-b630-5a8321b00739 - /sitecore/templates/FeatureJss/Media/Base/_MediaSearchData
// Comment: Inherits 8fd6c8b6-a9a4-4322-947e-90ce3d94916d - /sitecore/templates/Foundation/Indexing/_IndexedItem
// Comment: Inherits 0f8762a3-1b57-45c4-92cf-456371229819 - /sitecore/templates/Foundation/SitecoreContent/Tagging/Base/Tags Base
// Item: 810aa206-a05f-434b-a73a-58d4f3100295 - /sitecore/templates/FeatureJss/Media/Image/Media Search Image
export type MediaSearchImage = ImageBase & _MediaSearchData & _IndexedItem & TagsBase & {
}

// Comment: Inherits 23f8b2ac-1ff0-465b-afcc-45d17761bd6d - /sitecore/templates/FeatureJss/Media/Base/Caption Simple Base
// Item: 47ab2da3-4aac-4f7e-8daf-504feb694ea8 - /sitecore/templates/FeatureJss/Media/Image/Base/Image Base
export type ImageBase = CaptionSimpleBase & {
  source?: ImageField;
}

// Item: 75d399e5-edea-475f-8179-4df293ab2d6d - /sitecore/templates/FeatureJss/Media/Image/Base/_MediaSearchCategory
export type _MediaSearchCategory = {
  categoryTitle?: TextField;
}

// Item: c18d3794-d126-4548-bfc8-89358de6e9c1 - /sitecore/templates/FeatureJss/Media/Image Carousel/Image Carousel Folder
export type ImageCarouselFolder = {
}

// Comment: Inherits aaacbd6d-49b4-4086-8cd0-18e41f0c7b94 - /sitecore/templates/FeatureJss/Media/Image Carousel/Base/Image Carousel Slide Base
// Comment: Inherits beccb5ea-6b26-4502-bf1e-49bea92b0126 - /sitecore/templates/FeatureJss/Media/Base/Caption Base
// Item: 1777a862-046c-4cde-9480-89879d580b6c - /sitecore/templates/FeatureJss/Media/Image Carousel/Image Carousel Slide
export type ImageCarouselSlide = ImageCarouselSlideBase & CaptionBase & {
}

// Comment: Used by 2d23a1c6-2cb9-4b7d-b490-38a166034c8c - /sitecore/layout/Renderings/FeatureJss/Media/M19 Image Carousel
// Comment: Inherits 1e34acc9-043e-4f5e-8ddd-8b9043d58f40 - /sitecore/templates/FeatureJss/Media/Image Carousel/Base/Image Carousel Base
// Comment: Inherits d304a713-73c8-470e-9c58-cdb3ec174ac9 - /sitecore/templates/Foundation/SitecoreContent/Content/Base/Generic Header Base
// Item: 90a6893f-6d45-47d5-9dc3-d63300ec7b12 - /sitecore/templates/FeatureJss/Media/Image Carousel/Image Carousel
export type ImageCarousel = ImageCarouselBase & GenericHeaderBase & {
}

// Item: 1e34acc9-043e-4f5e-8ddd-8b9043d58f40 - /sitecore/templates/FeatureJss/Media/Image Carousel/Base/Image Carousel Base
export type ImageCarouselBase = {
}

// Item: aaacbd6d-49b4-4086-8cd0-18e41f0c7b94 - /sitecore/templates/FeatureJss/Media/Image Carousel/Base/Image Carousel Slide Base
export type ImageCarouselSlideBase = {
  imageRatio?: JssField<string>;
  source?: ImageField;
}

// Comment: Used by decebf43-99c3-4aca-8761-20a1e4c47e6f - /sitecore/layout/Renderings/FeatureJss/Media/M65 Image Quote
// Comment: Inherits 0614156e-dc81-437b-a2f8-b13e16f73ec4 - /sitecore/templates/FeatureJss/Media/Image Quote/Base/Image Quote Base
// Item: 1acb88d4-4cec-49c7-a9d1-054481989b56 - /sitecore/templates/FeatureJss/Media/Image Quote/Image Quote
export type ImageQuote = ImageQuoteBase & {
}

// Item: 0614156e-dc81-437b-a2f8-b13e16f73ec4 - /sitecore/templates/FeatureJss/Media/Image Quote/Base/Image Quote Base
export type ImageQuoteBase = {
  caption?: TextField;
  image?: ImageField;
  link?: LinkField;
  quote?: JssField;
}

// Comment: Used by 443f4426-c21e-4633-9a2c-347d0a38217a - /sitecore/layout/Renderings/FeatureJss/Media/M77 Internal Scroll
// Comment: Inherits fc5564f8-c228-4be6-89c9-172d228baf28 - /sitecore/templates/Foundation/Theme/Theme Rendering Parameters
// Comment: Inherits 00f230cc-187e-4df4-81d2-bcb60a51d5ed - /sitecore/templates/FeatureJss/Media/Base/Orientation Base
// Item: d4175bcc-81b5-4505-b095-f695a5d94a86 - /sitecore/templates/FeatureJss/Media/Internal Scroll/Internal Scroll Rendering Parameters
export type InternalScrollRenderingParameters = {
  orientation?: "0" | "1" | ""; // Text - Image=0|Image - Text=1
  backgroundTheme?: string; // code:Foundation.Theme.FieldSources.ThemeSource,Foundation.Theme
  usePageTheme?: "1" | ""; 
  variant?: string; // code:Foundation.Theme.FieldSources.VariantSource,Foundation.Theme
}

// Comment: Used by 443f4426-c21e-4633-9a2c-347d0a38217a - /sitecore/layout/Renderings/FeatureJss/Media/M77 Internal Scroll
// Comment: Inherits d304a713-73c8-470e-9c58-cdb3ec174ac9 - /sitecore/templates/Foundation/SitecoreContent/Content/Base/Generic Header Base
// Item: dd6c8a35-4a49-4a1b-ae9e-d5da6f87685c - /sitecore/templates/FeatureJss/Media/Internal Scroll/Internal Scroll
export type InternalScroll = GenericHeaderBase & {
  image1?: ImageField;
  image2?: ImageField;
  image3?: ImageField;
  image4?: ImageField;
  image5?: ImageField;
  image6?: ImageField;
  text?: RichTextField;
}

// Comment: Used by 79891900-4eff-4561-9ff3-ae7ea57aae70 - /sitecore/layout/Renderings/FeatureJss/Media/M33 Multi Column Promo
// Comment: Inherits fc5564f8-c228-4be6-89c9-172d228baf28 - /sitecore/templates/Foundation/Theme/Theme Rendering Parameters
// Item: 5b5d7911-383c-4425-84cf-2474233a63a0 - /sitecore/templates/FeatureJss/Media/Multi Column Promo/Multi Column Promo Rendering Parameters
export type MultiColumnPromoRenderingParameters = {
  orientation?: "0" | "1" | ""; // Large image last=0|Large image first=1
  backgroundTheme?: string; // code:Foundation.Theme.FieldSources.ThemeSource,Foundation.Theme
  usePageTheme?: "1" | ""; 
  variant?: string; // code:Foundation.Theme.FieldSources.VariantSource,Foundation.Theme
}

// Comment: Used by 79891900-4eff-4561-9ff3-ae7ea57aae70 - /sitecore/layout/Renderings/FeatureJss/Media/M33 Multi Column Promo
// Comment: Inherits 3f67e876-b22b-4d81-9491-474b46a4f993 - /sitecore/templates/FeatureJss/Media/Multi Column Promo/Base/Multi Column Promo Base
// Comment: Inherits d304a713-73c8-470e-9c58-cdb3ec174ac9 - /sitecore/templates/Foundation/SitecoreContent/Content/Base/Generic Header Base
// Item: 609bffec-e14d-4b8d-bc60-a40260b3c09c - /sitecore/templates/FeatureJss/Media/Multi Column Promo/Multi Column Promo
export type MultiColumnPromo = MultiColumnPromoBase & GenericHeaderBase & {
}

// Item: 3f67e876-b22b-4d81-9491-474b46a4f993 - /sitecore/templates/FeatureJss/Media/Multi Column Promo/Base/Multi Column Promo Base
export type MultiColumnPromoBase = {
  smallCallToActionBottom?: LinkField;
  largeCallToAction?: LinkField;
  largeImage?: ImageField;
  largeTitle?: TextField;
  smallCallToActionTop?: LinkField;
  smallImageBottom?: ImageField;
  smallImageTop?: ImageField;
  smallTitleBottom?: TextField;
  smallTitleTop?: TextField;
}

// Item: dd55d1ec-c0d7-4b9e-a30e-820728e5b78c - /sitecore/templates/FeatureJss/Media/Publication/Publication Folder
export type PublicationFolder = {
}

// Comment: Inherits 78b8fe9e-13e9-4cdb-a7f0-66eaa202c955 - /sitecore/templates/FeatureJss/Media/Publication/Base/_Publication
// Comment: Inherits 8fd6c8b6-a9a4-4322-947e-90ce3d94916d - /sitecore/templates/Foundation/Indexing/_IndexedItem
// Comment: Inherits 0f8762a3-1b57-45c4-92cf-456371229819 - /sitecore/templates/Foundation/SitecoreContent/Tagging/Base/Tags Base
// Item: be352ec7-22c0-42e6-a115-c266654dea36 - /sitecore/templates/FeatureJss/Media/Publication/Publication
export type Publication = _Publication & _IndexedItem & TagsBase & {
}

// Comment: Inherits 184051be-c603-4eed-a493-ea76d3159381 - /sitecore/templates/FeatureJss/Media/Publication/Base/_PublicationCategory
// Item: a0861ac3-7e0f-44e0-9ff5-f2dd1e6d1cf9 - /sitecore/templates/FeatureJss/Media/Publication/PublicationCategory
export type PublicationCategory = _PublicationCategory & {
}

// Item: 78b8fe9e-13e9-4cdb-a7f0-66eaa202c955 - /sitecore/templates/FeatureJss/Media/Publication/Base/_Publication
export type _Publication = {
  asset?: FileField;
  description?: JssField;
  image?: ImageField;
  publicationDate?: JssField<string>;
  title?: TextField;
}

// Item: 184051be-c603-4eed-a493-ea76d3159381 - /sitecore/templates/FeatureJss/Media/Publication/Base/_PublicationCategory
export type _PublicationCategory = {
  viewIssuesLink?: LinkField;
  viewIssuesText?: TextField;
  categoryDescription?: JssField;
  categoryImage?: ImageField;
  categoryTitle?: TextField;
}

// Comment: Used by 580faeb7-d3ff-48c2-8ad8-9ef9da2a978e - /sitecore/layout/Renderings/FeatureJss/Media/M103 Quotes on a Row Container
// Comment: Inherits 68d77353-ee7b-4baf-a2c1-261aa6c66add - /sitecore/templates/FeatureJss/Media/Quotes on a Row/Base/Quotes on a Row Container Base
// Item: a0a4aacb-0d3b-40f8-b624-ad87bdf7fe5e - /sitecore/templates/FeatureJss/Media/Quotes on a Row/Quotes on a Row Container
export type QuotesonaRowContainer = QuotesonaRowContainerBase & {
}

// Comment: Used by 61775726-8a73-468a-9471-22fc514948aa - /sitecore/layout/Renderings/FeatureJss/Media/M103 Quotes on a Row
// Comment: Inherits 17777ca2-62dd-4072-9e93-a01471acc123 - /sitecore/templates/FeatureJss/Media/Quotes on a Row/Base/Quotes on a Row Base
// Item: 4656673b-3224-4c8e-91b1-2b6315272bcb - /sitecore/templates/FeatureJss/Media/Quotes on a Row/Quotes on a Row
export type QuotesonaRow = QuotesonaRowBase & {
}

// Item: 17777ca2-62dd-4072-9e93-a01471acc123 - /sitecore/templates/FeatureJss/Media/Quotes on a Row/Base/Quotes on a Row Base
export type QuotesonaRowBase = {
  byline?: TextField;
  image?: ImageField;
  link?: LinkField;
  text?: JssField;
}

// Comment: Inherits d304a713-73c8-470e-9c58-cdb3ec174ac9 - /sitecore/templates/Foundation/SitecoreContent/Content/Base/Generic Header Base
// Item: 68d77353-ee7b-4baf-a2c1-261aa6c66add - /sitecore/templates/FeatureJss/Media/Quotes on a Row/Base/Quotes on a Row Container Base
export type QuotesonaRowContainerBase = GenericHeaderBase & {
}

// Comment: Inherits 9957fa16-f462-4d33-b772-b89b1bbbbd55 - /sitecore/templates/Foundation/SitecoreContent/Media/Vimeo Base
// Item: 61905634-eb5d-4ad1-ad0b-e71212748e0d - /sitecore/templates/FeatureJss/Media/Report Page Hero/Report Page Hero Base
export type ReportPageHeroBase = VimeoBase & {
  backLink?: LinkField;
  backgroundImage?: ImageField;
  backgroundVideo?: FileField;
  description?: JssField;
  headline?: JssField;
  primaryLink?: LinkField;
  secondaryLink?: LinkField;
  trumpet?: TextField;
}

// Item: 49d0d752-c2a4-42d7-828a-d7319bf33c5b - /sitecore/templates/FeatureJss/Media/Scroll Story/Scroll Story Folder
export type ScrollStoryFolder = {
}

// Comment: Inherits baa6c575-41ed-49c1-a2b9-8023e3738156 - /sitecore/templates/FeatureJss/Media/Scroll Story/Base/Scroll Story Intro Base
// Item: 21a74017-6965-4dd1-85cb-fc6de515aa2d - /sitecore/templates/FeatureJss/Media/Scroll Story/Scroll Story Intro
export type ScrollStoryIntro = ScrollStoryIntroBase & {
}

// Comment: Inherits b0462137-b003-45c0-ac26-e2d54c369453 - /sitecore/templates/FeatureJss/Media/Scroll Story/Base/Scroll Story Outro Base
// Item: f83023e2-765f-471e-8e81-cb574c5f0b45 - /sitecore/templates/FeatureJss/Media/Scroll Story/Scroll Story Outro
export type ScrollStoryOutro = ScrollStoryOutroBase & {
}

// Comment: Used by 89b63e53-0a49-4582-9ad7-09f6ad7f5b7c - /sitecore/layout/Renderings/FeatureJss/Media/M100 Scroll Story
// Comment: Inherits fc5564f8-c228-4be6-89c9-172d228baf28 - /sitecore/templates/Foundation/Theme/Theme Rendering Parameters
// Item: 63b3320e-8a54-4f3f-bfec-7f1619b54796 - /sitecore/templates/FeatureJss/Media/Scroll Story/Scroll Story Rendering Parameters
export type ScrollStoryRenderingParameters = {
  backgroundTheme?: string; // code:Foundation.Theme.FieldSources.ThemeSource,Foundation.Theme
  usePageTheme?: "1" | ""; 
  variant?: string; // code:Foundation.Theme.FieldSources.VariantSource,Foundation.Theme
}

// Item: eafaea86-f7b8-43d4-b541-6f9cd82997b7 - /sitecore/templates/FeatureJss/Media/Scroll Story/Scroll Story Section Folder
export type ScrollStorySectionFolder = {
}

// Comment: Inherits 280e7300-f7bc-460d-a998-546d5ac4bf35 - /sitecore/templates/FeatureJss/Media/Scroll Story/Base/Scroll Story Section Base
// Item: a9f6c388-aca7-4e42-bfea-aeff3e4e3557 - /sitecore/templates/FeatureJss/Media/Scroll Story/Scroll Story Section
export type ScrollStorySection = ScrollStorySectionBase & {
}

// Comment: Used by 89b63e53-0a49-4582-9ad7-09f6ad7f5b7c - /sitecore/layout/Renderings/FeatureJss/Media/M100 Scroll Story
// Comment: Inherits d304a713-73c8-470e-9c58-cdb3ec174ac9 - /sitecore/templates/Foundation/SitecoreContent/Content/Base/Generic Header Base
// Comment: Inherits 0f1c8aea-a989-4149-b583-f9c4557e3805 - /sitecore/templates/FeatureJss/Media/Scroll Story/Base/Scroll Story Base
// Item: 70f20fd1-c589-4b77-a195-5d1595a2f649 - /sitecore/templates/FeatureJss/Media/Scroll Story/Scroll Story
export type ScrollStory = GenericHeaderBase & ScrollStoryBase & {
}

// Item: 0f1c8aea-a989-4149-b583-f9c4557e3805 - /sitecore/templates/FeatureJss/Media/Scroll Story/Base/Scroll Story Base
export type ScrollStoryBase = {
  backgroundImage?: ImageField;
}

// Item: baa6c575-41ed-49c1-a2b9-8023e3738156 - /sitecore/templates/FeatureJss/Media/Scroll Story/Base/Scroll Story Intro Base
export type ScrollStoryIntroBase = {
  thirdColumnSubHeadline?: TextField;
  firstColumnSubHeadline?: TextField;
  firstColumnHeadline?: TextField;
  firstColumnImage?: ImageField;
  firstColumnText?: JssField;
  secondColumnImage?: ImageField;
  thirdColumnHeadline?: TextField;
  thirdColumnImage?: ImageField;
  thirdColumnText?: JssField;
}

// Item: b0462137-b003-45c0-ac26-e2d54c369453 - /sitecore/templates/FeatureJss/Media/Scroll Story/Base/Scroll Story Outro Base
export type ScrollStoryOutroBase = {
  thirdColumnSubHeadline?: TextField;
  firstColumnSubHeadline?: TextField;
  firstColumnHeadline?: TextField;
  firstColumnImage?: ImageField;
  firstColumnText?: JssField;
  secondColumnImage?: ImageField;
  thirdColumnHeadline?: TextField;
  thirdColumnImage?: ImageField;
  thirdColumnText?: JssField;
}

// Item: 280e7300-f7bc-460d-a998-546d5ac4bf35 - /sitecore/templates/FeatureJss/Media/Scroll Story/Base/Scroll Story Section Base
export type ScrollStorySectionBase = {
  firstColumnHeadline?: TextField;
  firstColumnImage?: ImageField;
  firstColumnText?: JssField;
  secondColumnImage?: ImageField;
  thirdColumnHeadline?: TextField;
  thirdColumnImage?: ImageField;
  thirdColumnText?: JssField;
}

// Comment: Used by c65513ed-77c4-4693-a3ab-66c98919aec3 - /sitecore/layout/Renderings/FeatureJss/Media/M31 Mega Teaser
// Comment: Inherits 00f230cc-187e-4df4-81d2-bcb60a51d5ed - /sitecore/templates/FeatureJss/Media/Base/Orientation Base
// Comment: Inherits fc5564f8-c228-4be6-89c9-172d228baf28 - /sitecore/templates/Foundation/Theme/Theme Rendering Parameters
// Item: 32e47cb6-8344-4ff9-91e1-ca6d8a7c75f3 - /sitecore/templates/FeatureJss/Media/Teaser/ParametersTemplate_MegaTeaser
export type ParametersTemplate_MegaTeaser = {
  imageRatio?: "" | "1" | ""; // Default=|Uncropped=1
  spacing?: string; // None=none
  orientation?: "0" | "1" | ""; // Text - Image=0|Image - Text=1
  backgroundTheme?: string; // code:Foundation.Theme.FieldSources.ThemeSource,Foundation.Theme
  usePageTheme?: "1" | ""; 
  variant?: string; // code:Foundation.Theme.FieldSources.VariantSource,Foundation.Theme
}

// Comment: Used by 66e1c797-7a5f-44d9-9445-f26d3b82d07d - /sitecore/layout/Renderings/FeatureJss/Media/M29 Teaser
// Comment: Inherits 00f230cc-187e-4df4-81d2-bcb60a51d5ed - /sitecore/templates/FeatureJss/Media/Base/Orientation Base
// Comment: Inherits fc5564f8-c228-4be6-89c9-172d228baf28 - /sitecore/templates/Foundation/Theme/Theme Rendering Parameters
// Item: dea7f531-ac84-4954-991a-dbd9f1a78a71 - /sitecore/templates/FeatureJss/Media/Teaser/ParametersTemplate_Teaser
export type ParametersTemplate_Teaser = {
  imageRatio?: "" | "1" | ""; // Default=|Uncropped=1
  spacing?: string; // None=none
  orientation?: "0" | "1" | ""; // Text - Image=0|Image - Text=1
  backgroundTheme?: string; // code:Foundation.Theme.FieldSources.ThemeSource,Foundation.Theme
  usePageTheme?: "1" | ""; 
  variant?: string; // code:Foundation.Theme.FieldSources.VariantSource,Foundation.Theme
}

// Item: b804b9b7-3e76-4b90-b467-be755038bca1 - /sitecore/templates/FeatureJss/Media/Teaser/Split Teaser Folder
export type SplitTeaserFolder = {
}

// Comment: Used by bdd3264c-8461-42e0-a6c5-ac142238b52e - /sitecore/layout/Renderings/FeatureJss/Media/M79 Split Teaser
// Comment: Inherits 22371447-bdd5-4512-abd0-2f1b9a2a378c - /sitecore/templates/FeatureJss/Media/Base/Split Teaser Base
// Comment: Inherits d304a713-73c8-470e-9c58-cdb3ec174ac9 - /sitecore/templates/Foundation/SitecoreContent/Content/Base/Generic Header Base
// Item: 1601093d-11f0-4949-96b0-faa7ffd9ddff - /sitecore/templates/FeatureJss/Media/Teaser/Split Teaser
export type SplitTeaser = SplitTeaserBase & GenericHeaderBase & {
}

// Item: 25024505-58c1-4f13-bcb4-a6e848605d65 - /sitecore/templates/FeatureJss/Media/Teaser/Teaser Folder
export type TeaserFolder = {
}

// Comment: Used by 66e1c797-7a5f-44d9-9445-f26d3b82d07d - /sitecore/layout/Renderings/FeatureJss/Media/M29 Teaser
// Comment: Inherits a08d21d1-186b-40a3-bb21-2b919abea9a4 - /sitecore/templates/FeatureJss/Media/Base/Teaser Base
// Item: cdd613c1-75d4-4985-a55e-061bd6601a70 - /sitecore/templates/FeatureJss/Media/Teaser/Teaser
export type Teaser = TeaserBase & {
}

// Comment: Used by ef9f9f34-894e-4d80-94f7-baa153628cc7 - /sitecore/layout/Renderings/FeatureJss/Media/M18 Video
// Comment: Inherits fc5564f8-c228-4be6-89c9-172d228baf28 - /sitecore/templates/Foundation/Theme/Theme Rendering Parameters
// Comment: Inherits 7207d83d-5518-4843-867e-55f5b5ffec22 - /sitecore/templates/Foundation/Theme/Base/Module Theme Base
// Item: 5483488b-e998-442a-b75a-2f5f38c11024 - /sitecore/templates/FeatureJss/Media/Video/Video Rendering Parameters
export type VideoRenderingParameters = {
  zoom?: "1" | ""; 
  moduleSpacing?: string; // None=none
  backgroundTheme?: string; // code:Foundation.Theme.FieldSources.ThemeSource,Foundation.Theme
  usePageTheme?: "1" | ""; 
  variant?: string; // code:Foundation.Theme.FieldSources.VariantSource,Foundation.Theme
}

// Comment: Used by ef9f9f34-894e-4d80-94f7-baa153628cc7 - /sitecore/layout/Renderings/FeatureJss/Media/M18 Video
// Comment: Inherits 815bdc12-c3b2-4554-a977-ed969b744e6a - /sitecore/templates/FeatureJss/Media/Video/Base/Video Base
// Comment: Inherits beccb5ea-6b26-4502-bf1e-49bea92b0126 - /sitecore/templates/FeatureJss/Media/Base/Caption Base
// Comment: Inherits d304a713-73c8-470e-9c58-cdb3ec174ac9 - /sitecore/templates/Foundation/SitecoreContent/Content/Base/Generic Header Base
// Item: cef52980-fb97-434f-baa5-a559ead3d6e3 - /sitecore/templates/FeatureJss/Media/Video/Video
export type Video = VideoBase & CaptionBase & GenericHeaderBase & {
}

// Item: 815bdc12-c3b2-4554-a977-ed969b744e6a - /sitecore/templates/FeatureJss/Media/Video/Base/Video Base
export type VideoBase = {
  autoplayVideo?: JssField<boolean>;
  thumbnail?: ImageField;
  vimeoID?: TextField;
  youTubeID?: TextField;
}


// Item: 565a62e6-973f-4729-9d80-7b31fbc87b36 - /sitecore/layout/Renderings/FeatureJss/Media/M00 Report Page Hero
export type ReportPageHeroProps = {
  fields?: Prettify<undefined>;
  params?: null;
  rendering: Rendering<Prettify<ReportPageHeroModel>, "subpage_navigation", undefined>;
}

// Item: 049ff961-500e-4156-8b13-d1c499a6dad1 - /sitecore/layout/Renderings/FeatureJss/Media/M00 Script Asset
export type ScriptAssetProps = {
  fields?: Prettify<ScriptAsset>;
  params?: null;
  rendering: Rendering<undefined, "subpage_navigation", undefined>;
}

// Item: acf5f9f9-6615-475a-9111-41b1e42cf23e - /sitecore/layout/Renderings/FeatureJss/Media/M08 Hero Carousel
export type HeroCarouselProps = {
  fields?: Prettify<HeroCarousel>;
  params?: null;
  rendering: Rendering<Prettify<HeroCarouselModel>, Record<string, string>, undefined>;
}

// Item: 89b63e53-0a49-4582-9ad7-09f6ad7f5b7c - /sitecore/layout/Renderings/FeatureJss/Media/M100 Scroll Story
export type ScrollStoryProps = {
  fields?: Prettify<ScrollStory>;
  params: ScrollStoryRenderingParameters;
  rendering: Rendering<undefined, Record<string, string>, SerializedItem[]>;
}

// Item: 580faeb7-d3ff-48c2-8ad8-9ef9da2a978e - /sitecore/layout/Renderings/FeatureJss/Media/M103 Quotes on a Row Container
export type QuotesonaRowContainerProps = {
  fields?: Prettify<QuotesonaRowContainer>;
  params: ThemeRenderingParameters;
  rendering: Rendering<undefined, "quotes_on_a_row_container", undefined>;
}

// Item: 61775726-8a73-468a-9471-22fc514948aa - /sitecore/layout/Renderings/FeatureJss/Media/M103 Quotes on a Row
export type QuotesonaRowProps = {
  fields?: Prettify<QuotesonaRow>;
  params?: null;
  rendering: Rendering<undefined, Record<string, string>, undefined>;
}

// Item: 3136006e-ec46-491c-98c2-ab4e41642f91 - /sitecore/layout/Renderings/FeatureJss/Media/M112 Hero
export type HeroProps = {
  fields?: Prettify<Hero>;
  params?: null;
  rendering: Rendering<undefined, "breadcrumb_navigation", undefined>;
}

// Item: 05c4b1ba-16ae-4b47-8c71-2b4420919070 - /sitecore/layout/Renderings/FeatureJss/Media/M119 Chapter Teaser
export type ChapterTeaserProps = {
  fields?: Prettify<ChapterTeaser>;
  params: ChapterTeaserRenderingParameters;
  rendering: Rendering<undefined, "chapter_teaser_documents_list", undefined>;
}

// Item: 27bb4599-9fbd-43a8-9d9c-0a0e9c0b1b4f - /sitecore/layout/Renderings/FeatureJss/Media/M120 Chapter Teaser Quote
export type ChapterTeaserQuoteProps = {
  fields?: Prettify<ChapterTeaserQuote>;
  params: ChapterTeaserRenderingParameters;
  rendering: Rendering<undefined, "chapter_teaser_documents_list", undefined>;
}

// Item: 56774e05-9071-4d43-9ec2-914af3ce6d25 - /sitecore/layout/Renderings/FeatureJss/Media/M125 Document List Grid
export type DocumentListGridProps = {
  fields?: Prettify<DocumentListGrid>;
  params: DocumentListRenderingParameters;
  rendering: Rendering<undefined, Record<string, string>, SerializedItem[]>;
}

// Item: 9cdbf62d-5b79-4194-a31e-2d77417882dc - /sitecore/layout/Renderings/FeatureJss/Media/M126 Business Model
export type BusinessModelProps = {
  fields?: Prettify<BusinessModel>;
  params: ThemeRenderingParameters;
  rendering: Rendering<undefined, Record<string, string>, SerializedItem[]>;
}

// Item: 2375cbbd-4aef-449d-9a48-bb56e0906a1b - /sitecore/layout/Renderings/FeatureJss/Media/M17 Image
export type ImageProps = {
  fields?: Prettify<Image>;
  params: ImageRenderingParameters;
  rendering: Rendering<undefined, Record<string, string>, undefined>;
}

// Item: ef9f9f34-894e-4d80-94f7-baa153628cc7 - /sitecore/layout/Renderings/FeatureJss/Media/M18 Video
export type VideoProps = {
  fields?: Prettify<Video>;
  params: VideoRenderingParameters;
  rendering: Rendering<Prettify<VideoModel>, Record<string, string>, undefined>;
}

// Item: 2d23a1c6-2cb9-4b7d-b490-38a166034c8c - /sitecore/layout/Renderings/FeatureJss/Media/M19 Image Carousel
export type ImageCarouselProps = {
  fields?: Prettify<ImageCarousel>;
  params: ThemeRenderingParameters;
  rendering: Rendering<Prettify<ImageCarouselModel>, Record<string, string>, undefined>;
}

// Item: b04b39d5-2e92-4144-93d0-4b3c083da1be - /sitecore/layout/Renderings/FeatureJss/Media/M25 Card Container
export type CardContainerProps = {
  fields?: Prettify<CardContainer>;
  params: ParametersTemplate_CardContainer;
  rendering: Rendering<undefined, "card_container", undefined>;
}

// Item: 66e1c797-7a5f-44d9-9445-f26d3b82d07d - /sitecore/layout/Renderings/FeatureJss/Media/M29 Teaser
export type TeaserProps = {
  fields?: Prettify<Teaser>;
  params: ParametersTemplate_Teaser;
  rendering: Rendering<Prettify<TeaserModel>, Record<string, string>, undefined>;
}

// Item: c65513ed-77c4-4693-a3ab-66c98919aec3 - /sitecore/layout/Renderings/FeatureJss/Media/M31 Mega Teaser
export type MegaTeaserProps = {
  fields?: Prettify<Teaser>;
  params: ParametersTemplate_MegaTeaser;
  rendering: Rendering<undefined, Record<string, string>, undefined>;
}

// Item: 79891900-4eff-4561-9ff3-ae7ea57aae70 - /sitecore/layout/Renderings/FeatureJss/Media/M33 Multi Column Promo
export type MultiColumnPromoProps = {
  fields?: Prettify<MultiColumnPromo>;
  params: MultiColumnPromoRenderingParameters;
  rendering: Rendering<undefined, Record<string, string>, undefined>;
}

// Item: 3d88aae4-3cb5-4b95-9c83-2216e20823de - /sitecore/layout/Renderings/FeatureJss/Media/M55 Document List Two Column
export type DocumentListTwoColumnProps = {
  fields?: Prettify<DocumentsListTwoColumn>;
  params?: null;
  rendering: Rendering<Prettify<DocumentsListTwoColumnModel>, Record<string, string>, undefined>;
}

// Item: 4e6ed550-5ae9-4a84-97d9-f19ee6922786 - /sitecore/layout/Renderings/FeatureJss/Media/M55 Document List
export type DocumentListProps = {
  fields?: Prettify<DocumentList>;
  params: DocumentListRenderingParameters;
  rendering: Rendering<Prettify<DocumentsListModel>, Record<string, string>, SerializedItem[]>;
}

// Item: decebf43-99c3-4aca-8761-20a1e4c47e6f - /sitecore/layout/Renderings/FeatureJss/Media/M65 Image Quote
export type ImageQuoteProps = {
  fields?: Prettify<ImageQuote>;
  params: ThemeRenderingParameters;
  rendering: Rendering<undefined, Record<string, string>, undefined>;
}

// Item: c5422b0c-bf36-472b-967b-09a7f28b6819 - /sitecore/layout/Renderings/FeatureJss/Media/M70 Careers Widget
export type CareersWidgetProps = {
  fields?: Prettify<CareersWidget>;
  params?: null;
  rendering: Rendering<Prettify<CareerWidgetModel>, Record<string, string>, undefined>;
}

// Item: 443f4426-c21e-4633-9a2c-347d0a38217a - /sitecore/layout/Renderings/FeatureJss/Media/M77 Internal Scroll
export type InternalScrollProps = {
  fields?: Prettify<InternalScroll>;
  params: InternalScrollRenderingParameters;
  rendering: Rendering<undefined, Record<string, string>, undefined>;
}

// Item: 4047ab98-e0e7-4d6d-bb2c-34485d1e892a - /sitecore/layout/Renderings/FeatureJss/Media/M78 Large Teaser
export type LargeTeaserProps = {
  fields?: Prettify<Teaser>;
  params: ThemeRenderingParameters;
  rendering: Rendering<undefined, Record<string, string>, undefined>;
}

// Item: bdd3264c-8461-42e0-a6c5-ac142238b52e - /sitecore/layout/Renderings/FeatureJss/Media/M79 Split Teaser
export type SplitTeaserProps = {
  fields?: Prettify<SplitTeaser>;
  params: ParametersTemplate_MegaTeaser;
  rendering: Rendering<undefined, Record<string, string>, undefined>;
}

// Item: d7aed53d-705a-418b-a260-d3557d06cc4e - /sitecore/layout/Renderings/FeatureJss/Media/M89 Card
export type CardProps = {
  fields?: Prettify<Card>;
  params: ParametersTemplate_Card;
  rendering: Rendering<undefined, Record<string, string>, undefined>;
}

// Item: 031d9b2d-ba42-48e2-b710-3c2167ae4645 - /sitecore/layout/Renderings/FeatureJss/Media/M93 Micro Cards
export type MicroCardsProps = {
  fields?: Prettify<MicroCards>;
  params: ThemeRenderingParameters;
  rendering: Rendering<Prettify<MicroCardsModel>, Record<string, string>, undefined>;
}
